import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import CommonTitle from "../../components/common-title";
import ImageBox from "../../components/Image";
import FilterCover,{ Options } from "./filter";
import {getResumesVisible} from "../../service";
import usePagination from "../../routers/usePagination";
import Pagination from "../../components/pagination";
import {ResumesData} from "../types";
import n2 from '../../images/n2.png'


const options:Array<Options> = [
    {
        name:'管家星级',
        options:[
            {
                id:-1,
                name:'不限'
            },
            {
                id:0,
                name:'认证管家'
            },
            {
                id:1,
                name:'一星管家'
            },
            {
                id:2,
                name:'二星管家'
            },
            {
                id:3,
                name:'三星管家'
            },
            {
                id:4,
                name:'首席大管家'
            }
        ]
    },
    {
        name:'管家国籍',
        options:[
            {
                id:-1,
                name:'不限'
            },
            {
                id:0,
                name:'中国地区'
            },
            {
                id:1,
                name:'港澳台地区'
            },
            {
                id:2,
                name:'其他国家'
            }
        ]
    },
    {
        name:'管家年龄',
        options:[
            {
                id:-1,
                name:'不限'
            },
            {
                id:0,
                name:'28-35岁'
            },
            {
                id:1,
                name:'35-40岁'
            },
            {
                id:2,
                name:'40-45岁'
            },
            {
                id:3,
                name:'45岁以上'
            }
        ]
    },
]

const star:string[] = ['普通会员','一星管家','二星管家','三星管家','首席大管家']

function Personnel(){

    const [status,setStatus] = useState<boolean>(false);
    const [filter,setFilter] = useState<Array<string>>(['-1','-1','-1']);
    const [pageNum,setPage] = useState<number>(1);
    const { pageRef,noMore,reset } = usePagination();
    const [lists,setLists] = useState<Array<ResumesData>>([])

    const coverClose = () =>{
        setStatus(false)
    }

    const coverChange = (n:Array<Array<number>>) => {
        console.log(n)
        setFilter(n.map(item => item.toString()))
        coverClose()
        reset()
        setPage(1)
        setLists([])
    }

    useEffect(() => {
        console.log(filter)
        getResumesVisible({
            pageNum,
            stars:filter[0],
            regions:filter[1],
            ages:filter[2],
        }).then(res => {
            if(res.code === 1){
                const lists = res.data.list
                if((lists as Array<ResumesData>).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            }else{
                noMore()
            }
        })
    },[pageNum,filter])

    return <div className="jobs">
        <div className="cover-box">
            <Link to={'/user/resume'}>
                <div className="bg" style={{ backgroundImage:`url(${ n2 })` }}/>
                <div className="text small">
                    <h3>完善简历 获取高薪工作机会</h3>
                    <div className="iconfont">&#xe608;</div>
                </div>
            </Link>
        </div>
        <CommonTitle title={ 'BG人才库' }>
            <div className="common-more filter-btn" onClick={() => setStatus(true)}>
                <p><span className="iconfont">&#xe6c8;</span>筛选</p>
            </div>
        </CommonTitle>
        <div className="p-lists">
            {
                lists.map((item,index) => {
                    return <Link to={`/job/personnel/${ item.id }/detail`} key={index}>
                        <p className="n" style={{ borderBottom:'1px solid #eee' }}>国际职业管家联盟认证编号：{ item.authNumber || '暂无' }</p>
                        <div className="tabsStar"/>
                        <div className="tabsStarText">{ star[item.stars] }</div>
                        <div className="flex">
                            <div className="img-box">
                                <ImageBox height={145} src={ item.photo }/>
                            </div>
                            <div className="text">
                                <h3>{ item.fullName } &nbsp;&nbsp; { item.sex === 1 && '男士' }{ item.sex === 2 && '女士' }</h3>
                                <div className="detail">
                                    <p>个人优势：</p>
                                    <p style={{ color:'#888' }}>{ item.skill }</p>
                                </div>
                            </div>
                        </div>
                    </Link>
                })
            }
        </div>
        <Pagination ref={pageRef} length={lists.length} onChange={ (n) => setPage(n) }/>
        <FilterCover show={ status } onClose={ () => coverClose() } onChange={ (n) => { coverChange(n) } } options={ options }/>
    </div>
}

export default Personnel
